import { IconButtonProps as RadixIconButtonProps } from '@radix-ui/themes';

import { FlyThemeColor } from '../utils';

type IconButtonSize = '1' | '2' | '3' | '4';

export type IconButtonProps = Omit<
  RadixIconButtonProps,
  'color' | 'size' | 'radius' | 'children'
> & {
  color?: FlyThemeColor;
  size?: IconButtonSize;
  icon: React.ReactNode | string;
  iconSize?: number;
  iconClassName?: string;
  to?: string;
};

export const sizeToIconSizeMap: Record<IconButtonSize, number> = {
  '1': 16,
  '2': 16,
  '3': 18,
  '4': 20,
};

export const sizeToClassNameMap: Record<IconButtonSize, string> = {
  '1': 'rounded-[50%] h-6 w-6',
  '2': 'rounded-[50%] h-8 w-8',
  '3': 'rounded-fly-4 h-10 w-10',
  '4': 'rounded-fly-4 h-12 w-12',
};
